import { Component, OnInit } from '@angular/core';
import { ClientesService } from 'src/app/services/clientes.service';
import { Ng2IzitoastService } from "ng2-izitoast";
import { GruposService } from 'src/app/services/grupos.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reporte-produccion',
  templateUrl: './reporte-produccion.component.html',
  styleUrls: ['./reporte-produccion.component.scss']
})
export class ReporteProduccionComponent implements OnInit {
  enviroment = environment.BASE_URL;

  respuestaClientes:any;
  respuestaPagos:any;
  respuestGrupos:any;
  clientes:any;
  clientesGrupo:any;

  clientesEstatusDos:any;

  data:any;
  grupos:any;
  respuestaAgregarPagos:any;

  grupoId:any;

  keyword = 'nombre';

  constructor( private _getClientes:ClientesService, public iziToast: Ng2IzitoastService, 
    private _getGrupos: GruposService,
    private _agregarPago:ClientesService) { }

  ngOnInit(): void {
    // this.getClientesProduccion();
    this.getGrupos();

  }

  getClientesProduccion(){
    this._getClientes.getClientesProduccion().subscribe(
      data => {
        this.respuestaClientes = data;
        if(this.respuestaClientes.success){
          this.clientes = this.respuestaClientes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  getGrupos(){
    this._getGrupos.getGruposNombre().subscribe(
      data => {
        this.respuestGrupos = data;
        if(this.respuestGrupos.success){
          this.grupos = this.respuestGrupos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getClientesProduccionFiltro(grupo, estatus){
    this.data = {
      'grupo':grupo,
      'estatus':estatus,
    }

    this._getClientes.getClientesProduccionFiltro(this.data).subscribe(
      data => {
        this.respuestaClientes = data;
        if(this.respuestaClientes.success){
          this.clientes = this.respuestaClientes.content;
          this.clientesGrupo = this.respuestaClientes.clientesGrupo;
          this.clientesEstatusDos = this.respuestaClientes.clientesEstatusDos;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

    
  }
  updateEstatus(estatus, dataId){
    this.data = {
      'estatus':estatus,
      'usuario':dataId,
    }

    this._agregarPago.updateEstatus(this.data).subscribe(
      data => {
        this.respuestaAgregarPagos = data;
        if(this.respuestaAgregarPagos.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getClientesProduccion();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  selectEvent(item) {
    console.log(item.id);
    this.grupoId = item.id
    // do something with selected item
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  
  onFocused(e){
    // do something when input is focused
  }

  descargarExcel(grupo, estatus){
    window.location.replace(this.enviroment+'/api/descargarExcelProduccion?grupo='+grupo+'&estatus='+estatus);

  }

}
